<template lang="pug">
  v-card.mb-3
    .list-mobile__top
      .list-mobile__title.list-mobile__title--size-lg {{ item.name | shortstr }}
      .list-mobile__actions
        v-btn(
          icon
          :disabled="!hasPermission('schedule', 'change', 'animalfeed')"
          @click="setCurrentSchedule(item)")
          v-icon(
            font-size="1.1"
            icon="cog")
        v-btn(
          icon
          @click="toggle")
          template(
            v-if="isOpen")
            v-icon(
              font-size="1"
              icon="chevron-up")
          template(
            v-else)
            v-icon(
              font-size="1"
              icon="chevron-down")
    transition(name="fade")
      template(v-if="!isOpen")
        .list-mobile__content
          .list-mobile__item
            .list-mobile__item-label {{ 'base.eat_on_day' | translate }}
            .list-mobile__item-value {{ item.daily_feed_intake | rounding }}
          .list-mobile__item
            .list-mobile__item-label {{ 'base.on_stock' | translate }}
            .list-mobile__item-value {{ (item.total_amount || 0) | rounding }}
          .list-mobile__item
            .list-mobile__item-label {{ 'base.mixing' | translate }} [{{ 'base.kg' | translate }}] {{ 'base.plan_fact' | translate }}
            .list-mobile__item-value {{ (item.plan_weight || 0) | rounding }} / {{ (item.fact_weight || 0) | rounding }}
          .list-mobile__item
            .list-mobile__item-label {{ 'base.date' | translate }}
            .list-mobile__item-value {{ item.planned_on | date }}
          //- Час змішування присутній в налаштуваннях
          //- .list-mobile__item
                .list-mobile__item-label Час змішування
                .list-mobile__item-value
                  ui-number-input(
                    postfix="хв"
                    v-model="item.mix_time"
                    @input="updateCurrentRow")
          .list-mobile__item
            .list-mobile__item-label(:class="status") {{ statusLabel | translate}}
            .list-mobile__item-value
              v-switch(
                :disabled="!hasPermission('schedule', 'change', 'animalfeed')"
                v-model="item.is_active"
                @input="updateCurrentRow")
    transition(name="fade")
      template(v-if="isOpen")
        div
          v-divider(thin)
          .list-mobile__content.list-mobile__content--offset-md
            .list-mobile__item
              .list-mobile__title.list-mobile__title--size-lg.list-mobile__title--underline {{ item.schedule_animalfeed_recipe.name }}
            .list-mobile__item.list-mobile__item--no-border.list-mobile__item--offset-sm
              .list-mobile__item-label {{ 'sidebar.ingredients' | translate }}
            .list-mobile__section(
              v-for="ingredient in item.schedule_animalfeed_recipe.schedule_ingredients"
              :key="ingredient.id")
              .list-mobile__item
                .list-mobile__title.list-mobile__title--size-lg {{ ingredient.name }}
              .list-mobile__item.list-mobile__item--no-border
                .list-mobile__item-label {{ 'base.mixing' | translate }} [{{ 'base.kg' | translate }}] {{ 'base.plan_fact' | translate }}
                .list-mobile__item-value {{ (ingredient.plan_weight || 0) | rounding }} / {{ (ingredient.fact_weight || 0) | rounding }}
              .list-mobile__item.list-mobile__item--no-border
                .list-mobile__item-label {{ 'base.price' | translate }}
                .list-mobile__item-value {{ ingredient.fact_price | floor }}
</template>

<script>
import { mapActions } from 'vuex'

import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'

export default {
  name: 'PlanningTableRowMobile',

  components: {
    UiNumberInput
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    isOpen: false
  }),

  computed: {
    statusLabel () {
      return this.item.is_active
        ? 'base.use'
        : 'base.not_use'
    },

    status () {
      return this.item.is_active
        ? 'text-success'
        : 'text-danger'
    }
  },

  methods: {
    ...mapActions('animalfeed', [
      'setCurrentSchedule',
      'updateSchedule'
    ]),

    updateCurrentRow () {
      this.updateSchedule({
        id: this.item.id,
        payload: this.item
      })
    },

    toggle () {
      this.isOpen = !this.isOpen
    }
  }
}
</script>
